import { DeploymentType } from "../../Data/Models/configuration";
import { getConfiguration } from "../../Util/ConfigHelper";
import { BaseFeatureUi } from "../Base/BaseFeatureUi";

export class ScormFeatureUi extends BaseFeatureUi {

    isShowExitButton(): boolean {
        // only show the Exit button for SCORM deployments
        const config = getConfiguration();
        return config.deploymentType === DeploymentType.Scorm;
    }
}